import React from 'react'

export default function IRecharge() {
  return (
    <div>IRecharge coming soon, Anticipate</div>
  )
}
